module.exports = __webpack_public_path__ + "img/img_4.ca0e1693.png";